<div class="d-flex">
    <h1 class="page-title">
        <i class="pi pi-angle-left" [routerLink]="['/dashboard']" routerLinkActive="router-link-active" ></i>
        Add New Card
    </h1>
</div>
<p-card class="add-new-card">
    <div class="payment-methods">
        <button class="payment-method-btn" [class.active]="paymentMethod === 'card'"
            (click)="selectPaymentMethod('card')">
            <span class="method-label">Cards</span>
            <div class="card-logos">
                <img src="https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png" alt="Mastercard">
                <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa">
                <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/American_Express_logo_%282018%29.svg"
                    alt="Amex">
                <img src="https://upload.wikimedia.org/wikipedia/commons/4/41/Discover_Card_logo.svg" alt="Discover">
            </div>
        </button>

        <button class="payment-method-btn" [class.active]="paymentMethod === 'google'"
            (click)="selectPaymentMethod('google')">
            <span class="method-label">Google Pay</span>
            <img src="https://upload.wikimedia.org/wikipedia/commons/f/f2/Google_Pay_Logo.svg" alt="Google Pay"
                class="gpay-logo">
        </button>
    </div>

    <form [formGroup]="cardForm" (ngSubmit)="onSubmit()" *ngIf="paymentMethod === 'card'">
        <div class="form-group">
            <label for="nameOnCard">Name on card</label>
            <input type="text" id="nameOnCard" formControlName="nameOnCard" placeholder="John Doe">
        </div>

        <div class="form-group">
            <label for="cardNumber">Card number</label>
            <input type="text" id="cardNumber" formControlName="cardNumber" placeholder="0000 0000 0000 0000"
                maxlength="19" (input)="formatCardNumber($event)">
        </div>

        <div class="form-row">
            <div class="form-group">
                <label for="expiryMonth">Card expiration</label>
                <div class="select-wrapper">
                    <select id="expiryMonth" formControlName="expiryMonth">
                        <option value="" disabled selected>Month</option>
                        <option *ngFor="let month of months" [value]="month.value">
                            {{ month.label }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="form-group">
                <label>&nbsp;</label>
                <div class="select-wrapper">
                    <select formControlName="expiryYear">
                        <option value="" disabled selected>Year</option>
                        <option *ngFor="let year of years" [value]="year">
                            {{ year }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="form-group">
            <label for="cvv">CCV code</label>
            <div class="cvv-input-wrapper">
                <input type="text" id="cvv" formControlName="cvv" placeholder="Code" maxlength="4">
                <span class="help-icon">?</span>
            </div>
        </div>

        <button type="submit" class="submit-btn" [disabled]="!cardForm.valid">
            Add & Proceed
        </button>
    </form>
</p-card>